import { useEffect, useRef } from 'react';

import { ThaiInspiredLoader } from '@/components/loaders/thai-inspired-loader';

import { performLogout } from '../performLogout';

/**
 * Route component for `/logout`.
 *
 * Runs the logout in an effect rather than during render — the previous
 * implementation called its (no-op) helper inline in `PublicRoute`'s render body,
 * which would re-fire on every re-render once the call actually did something.
 * The ref guards against React 18 double-invoking the effect in StrictMode.
 */
const LogoutRoute = () => {
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    void performLogout();
  }, []);

  return <ThaiInspiredLoader text="Signing out..." />;
};

export default LogoutRoute;
